module.exports = __webpack_public_path__ + "static/media/Home-3.8edd4015.svg";